import React from 'react';

export const ResearchSection = () => {
  const frameworks = [
    'P-CMM · Carnegie Mellon',
    'Balanced Scorecard · Kaplan & Norton',
    'HR Scorecard · Becker, Huselid & Ulrich',
    'HR Roles Model · Dave Ulrich',
    'CMMI · Process Maturity',
    'Systemic HR · Josh Bersin'
  ];

  const references = [
    'Gartner',
    'McKinsey',
    'Josh Bersin Company',
    'Deloitte',
    'NASSCOM',
    'SHRM',
    'World Economic Forum'
  ];

  return (
    <section className="research">
      <div className="research-inner">
        <div className="research-label">Research Foundations</div>
        <div className="research-title">Standing on established science. Not vendor pitches.</div>
        <div className="research-sub">
          The AI Maturity Model for HR draws on decades of validated management science, triangulated with primary research and operational data from 150,000+ AI-driven hires.
        </div>

        <div className="pillars">
          <div className="pillar">
            <div className="pillar-icon">🎙️</div>
            <div className="pillar-title">Primary Research</div>
            <div className="pillar-text">
              Semi-structured interviews with HR leaders across Indian enterprises. Qualitative methodology capturing the nuanced, context-dependent nature of AI transformation.
            </div>
            <div className="pillar-stat">30+ CHROs</div>
          </div>

          <div className="pillar">
            <div className="pillar-icon">⚙️</div>
            <div className="pillar-title">Operational Data</div>
            <div className="pillar-text">
              Aggregated, anonymised insights from iona.ai deployments since 2018. Process efficiency, quality metrics, governance effectiveness, and scaling patterns.
            </div>
            <div className="pillar-stat">150K+ hires</div>
          </div>

          <div className="pillar">
            <div className="pillar-icon">📚</div>
            <div className="pillar-title">Framework Synthesis</div>
            <div className="pillar-text">
              Systematic review and integration of established management science frameworks validated across decades of organisational research worldwide.
            </div>
            <div className="pillar-stat">6 frameworks</div>
          </div>
        </div>

        <div className="framework-dna">
          {frameworks.map((framework, idx) => (
            <div key={idx} className="dna-tag">{framework}</div>
          ))}
        </div>

        <div className="ref-strip">
          <div className="ref-label">Industry research referenced</div>
          {references.map((ref, idx) => (
            <span key={idx} className="ref-name">{ref}</span>
          ))}
        </div>
      </div>
    </section>
  );
};
